<template>
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200.000000 132.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(-54.000000, 190.000000) scale(0.100000,-0.100000)"
            :fill="`${uiStore.cssThemeVariables.primaryFont}`"
            stroke="none">
            <path
                d="M705 1846 c-59 -27 -106 -77 -129 -138 -15 -38 -17 -82 -14 -348 3
-334 3 -334 67 -397 60 -60 89 -68 286 -73 l180 -5 6 -51 c13 -105 91 -176
210 -190 68 -8 133 5 258 53 134 50 195 50 316 -1 111 -46 187 -56 251 -31
114 43 185 164 154 262 -7 21 -34 76 -61 123 -57 99 -63 152 -29 221 18 34 23
38 40 29 24 -13 91 -13 127 1 15 5 41 22 56 37 35 33 99 156 91 175 -3 8 -17
20 -32 28 -15 7 -28 14 -30 15 -2 1 10 29 27 62 22 44 27 62 18 71 -24 24 -45
11 -71 -44 -14 -30 -29 -55 -34 -55 -14 0 -102 40 -102 47 0 3 12 27 26 53 29
54 29 84 -2 88 -16 2 -25 -8 -44 -48 -13 -28 -27 -53 -31 -56 -4 -2 -24 3 -44
13 -44 21 -51 15 -94 -84 -48 -110 -40 -172 27 -237 l30 -28 -17 -42 c-43
-100 -36 -157 35 -279 76 -131 71 -203 -18 -267 -55 -40 -137 -42 -216 -5
-139 65 -232 71 -362 24 -178 -64 -268 -75 -336 -43 -41 20 -84 87 -84 132 l0
31 178 3 c168 3 180 4 227 29 56 28 109 91 125 147 14 53 13 570 -2 630 -15
60 -94 142 -154 160 -29 8 -150 12 -410 12 -365 0 -369 0 -419 -24z m840 -69
c22 -13 49 -40 62 -62 22 -39 23 -48 23 -334 l0 -294 -25 -43 c-14 -23 -42
-53 -62 -66 l-38 -23 -375 0 -375 0 -38 24 c-21 13 -50 42 -65 64 l-27 41 0
285 c0 157 3 298 7 313 11 37 56 88 93 104 23 10 116 13 405 13 371 1 375 0
415 -22z m719 -198 c17 -10 65 -32 106 -50 41 -17 76 -33 78 -34 2 -2 -11 -28
-28 -59 -50 -89 -103 -105 -196 -62 -94 44 -115 106 -69 205 l25 53 27 -17
c14 -10 40 -26 57 -36z" />
            <path
                d="M915 1584 c-11 -8 -36 -19 -57 -25 -42 -11 -53 -39 -15 -39 34 0 111
42 115 63 4 21 -16 22 -43 1z" />
            <path
                d="M1302 1583 c4 -21 85 -65 112 -61 35 5 28 27 -11 37 -21 6 -47 17
-58 25 -27 21 -47 20 -43 -1z" />
            <path
                d="M892 1468 c-18 -18 -15 -113 4 -132 18 -19 20 -19 45 -6 15 9 19 22
19 68 0 59 -11 82 -40 82 -9 0 -21 -5 -28 -12z" />
            <path
                d="M1312 1468 c-7 -7 -12 -38 -12 -70 0 -46 4 -59 19 -68 25 -13 27 -13
45 6 35 34 13 144 -28 144 -6 0 -17 -5 -24 -12z" />
            <path
                d="M1060 1258 c-72 -25 -150 -137 -120 -173 21 -25 38 -17 59 30 12 27
33 52 53 65 66 40 168 16 197 -47 7 -15 17 -35 21 -43 4 -8 16 -16 28 -18 41
-6 37 55 -9 120 -42 58 -154 91 -229 66z" />
        </g>
    </svg>
</template>
<script setup lang="ts">
import { useUIStore } from '@/stores/uiStore.ts';

const uiStore = useUIStore();
</script>
